export default __webpack_public_path__ + "static/media/tip2.04aee962.png";